import BaseService from './base.service';

export default class AccountService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    create = data => {
        return this.post('account/create', data);
    };

    getUser = data => {
        return this.get('account/user', data);
    };

    forgotPassword = data => {
        return this.post('account/forgot-password', data);
    };

    update = data => {
        return this.put('account/update', data);
    };

    changePassword = values => {
        return this.post('/account/change-password', values);
    };

    requestDelAccount = (values = {}) => {
        return this.delete('/account/request-delete', values);
    };
}
